import Pipeline from '@pipeline-ui-2/pipeline';
export default Pipeline;